import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctTimestamp } from '../../../../Fct/generics/FctParams';
import { votingEscrowContract } from '../helpers/supportedContracts';
export var IncreaseUnlockTime = createPlugin({
    protocol: 'CURVE',
    type: 'ACTION',
    method: 'increase_unlock_time',
    name: 'increaseCurveTokenLock',
    description: 'Extend the unlock time on a lock that already exists.',
    supportedContracts: votingEscrowContract,
    getParams: function () { return ({
        input: {
            to: new FctAddress({ destination: 'curve_voting_escrow', options: votingEscrowContract }),
            methodParams: {
                unlock_time: new FctTimestamp({}),
            },
        },
        output: {},
    }); },
});
